// extracted by mini-css-extract-plugin
export default {"container":"TitleItem_container__l31OY","imgContainer":"TitleItem_imgContainer__zxVBP","title":"TitleItem_title__3Vb+4","dot":"TitleItem_dot__FVKKe"};